/**
 * Relative luminance (sRGB) — 0 black, 1 white.
 * Mirrors rn-ticketack-mobile/src/helpers/statusBarTheme.js.
 * @param {string} color
 * @returns {number|null}
 */
export function relative_luminance(color) {
    const raw = String(color || '').trim();
    const hex = raw.replace(/^#/, '');
    let r;
    let g;
    let b;
    if (/^[0-9a-fA-F]{3}$/.test(hex)) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else if (/^[0-9a-fA-F]{6}$/.test(hex) || /^[0-9a-fA-F]{8}$/.test(hex)) {
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
    } else {
        return null;
    }
    const to_linear = (c) => {
        const s = c / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * to_linear(r) + 0.7152 * to_linear(g) + 0.0722 * to_linear(b);
}

/**
 * True when the background is light enough that status-bar glyphs should be dark.
 * @param {string} color
 * @returns {boolean}
 */
export function is_light_background(color) {
    const lum = relative_luminance(color);
    if (lum === null)
        return false;
    return lum > 0.55;
}

/**
 * Auto status-bar icon mode from theme background colour.
 * @param {string} [background]
 * @returns {'dark'|'light'}
 */
export function auto_status_bar_icons(background) {
    return is_light_background(background || '#000000') ? 'dark' : 'light';
}

export function normalize_status_bar_background(value) {
    const raw = String(value ?? '').trim();
    if (!raw || raw.toLowerCase() === 'transparent')
        return null;
    return raw;
}

export function resolve_status_bar_contrast_background(content_background, status_bar_background) {
    return normalize_status_bar_background(status_bar_background)
        || content_background
        || '#000000';
}
